/* Laekfriends Theme JS – Vanilla, ohne externe Abhängigkeiten */
(function () {
  'use strict';

  /* ---------------- Mobile Navigation ---------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('SiteNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------- Untermenue (Mobile-Akkordeon) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-submenu-toggle]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.site-nav__item');
    if (!item) return;
    var expanded = item.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  /* ---------------- Mengen-Steuerung (+ / -) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
    var min = parseInt(input.min || '0', 10);
    var value = (parseInt(input.value, 10) || min) + step;
    if (value < min) value = min;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Produktgalerie ---------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main] img');
    var img = thumb.querySelector('img');
    if (!main || !img) return;
    main.src = thumb.getAttribute('data-src-large') || img.src;
    main.srcset = '';
    main.alt = img.alt || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---------------- Variantenwahl: Preis & Verfügbarkeit ---------------- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (container) {
      var select = container.querySelector('[data-variant-select]');
      var dataEl = container.querySelector('[data-variant-json]');
      if (!select || !dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var priceEl = container.querySelector('[data-price]');
      var compareEl = container.querySelector('[data-compare-price]');
      var addBtn = container.querySelector('[data-add-to-cart]');

      select.addEventListener('change', function () {
        var v = variants[select.value];
        if (!v) return;
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) {
          if (v.compare_at_price) {
            compareEl.textContent = v.compare_at_price;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available
            ? addBtn.getAttribute('data-label-add')
            : addBtn.getAttribute('data-label-soldout');
        }
      });
    });
  }

  /* ---------------- AJAX: In den Warenkorb ---------------- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () { /* still */ });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-to-cart]');
    var original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-label-adding') || original;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      })
      .then(function () {
        updateCartCount();
        if (btn) {
          btn.textContent = btn.getAttribute('data-label-added') || original;
          window.setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        }
      })
      .catch(function (err) {
        if (btn) {
          btn.textContent = original;
          btn.disabled = false;
        }
        var msg = (err && err.description) ? String(err.description) : 'Der Artikel konnte nicht hinzugefügt werden.';
        var note = form.querySelector('[data-cart-error]');
        if (note) {
          note.textContent = msg;
          note.hidden = false;
        }
      });
  });

  /* ---------------- Warenkorbseite: Menge ändert -> Formular senden ---------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    var form = input.closest('form');
    if (form) form.submit();
  });

  /* ---------------- Sortierung Collection ---------------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  document.addEventListener('DOMContentLoaded', function () {
    initProductForms();
    updateCartCount();
  });
})();
